import {
    faClose
} from '@fortawesome/pro-regular-svg-icons/faClose';
import {
    FontAwesomeIcon
} from '@fortawesome/react-fontawesome';
import {
    Box,
    Button,
    Modal as MUIModal
} from '@mui/material';
import {
    type FC
} from 'react';

import type {
    ModalProps
} from './types';

import styles from './styles';

const Modal: FC<ModalProps> = (props) => {
    const {
        children,
        handleClose,
        isVisible
    } = props;

    return (
        <MUIModal
            onClose={handleClose}
            open={isVisible}
        >
            <Box sx={styles.wrapper}>
                <Box sx={styles.modal}>
                    <Button
                        onClick={handleClose}
                        sx={styles.close}
                        variant={'contained'}
                    >
                        <FontAwesomeIcon
                            icon={faClose}
                            size={'2x'}
                        />
                    </Button>
                    {children}
                </Box>
            </Box>
        </MUIModal>
    );
};

export default Modal;
